module.exports = __webpack_public_path__ + "img/PJ.b0ee0e57.png";